import React from 'react';
import { bool, shape, string } from 'prop-types';
import ClassNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BaseComponent from '../.internal/BaseComponent';
import ICON_LIBRARY from './IconLibrary';

import './Icon.scss';

// TODO: Backwards compatibility - remove everythings aside from --default and --sm once completely deprecated
const sizeList = {
  lg: 'icon--lg',
  md: 'icon--md',
  sm: 'icon--sm',
  xl: 'icon--xl',
  xs: 'icon--xs',
  xxl: 'icon--xxl'
};

export default class Icon extends BaseComponent {
  renderSvgIcon = (icon, className) => {
    const SvgIcon = ICON_LIBRARY[icon].asset;

    return <SvgIcon className={className} />;
  };

  render() {
    const { icon, style, className, id, spin, pulse, size } = this.props;
    const classNames = ClassNames('icon', className, sizeList[size]);

    return Object.prototype.hasOwnProperty.call(ICON_LIBRARY, icon) ? (
      <>
        {ICON_LIBRARY[icon].type === 'fa' ? (
          <FontAwesomeIcon
            className={classNames}
            icon={ICON_LIBRARY[icon].asset}
            id={id}
            pulse={pulse}
            spin={spin}
            style={style}
          />
        ) : (
          this.renderSvgIcon(icon, classNames)
        )}
      </>
    ) : null;
  }
}

Icon.propTypes = {
  className: string,
  icon: string.isRequired,
  id: string,
  pulse: bool,
  size: string,
  spin: bool,
  style: shape({})
};

Icon.defaultProps = {
  className: undefined,
  id: undefined,
  pulse: false,
  size: 'default',
  spin: false,
  style: undefined
};
